import { Tooltip, TooltipProps } from '@sgme/ui';
import classNames from 'classnames';
import { useFieldValidationError } from 'components/common-form/hooks/useFieldValidationError';
import { FC } from 'react';
import styled from 'styled-components';

import type { CommonFormGroupProps } from './model';

export const StyledGridDiv = styled.div<{ $minWidth?: number; $maxWidth?: number }>`
  min-width: ${({ $minWidth }) => ($minWidth !== undefined ? $minWidth.toString() + 'px' : undefined)};
  max-width: ${({ $maxWidth }) => ($maxWidth !== undefined ? $maxWidth.toString() + 'px' : undefined)};
  height: 100%;
`;

export interface GridFormGroupProps extends CommonFormGroupProps {}

export const GridFormGroup: FC<GridFormGroupProps> = ({
  minWidth,
  maxWidth,
  tooltipLocation,
  children,
  inputId,
  className,
}) => {
  const validationError = useFieldValidationError(inputId, 'quote.errorMessages.');

  if (validationError) {
    const { message, severity } = validationError;
    const color: TooltipProps['color'] = severity === 'Warning' ? 'info' : 'warning';

    const errorContent = (
      <StyledGridDiv
        data-e2e={`${inputId}-grid-form-group`}
        $minWidth={minWidth}
        $maxWidth={maxWidth}
        className={classNames(`border-bottom border-${color}`, className)}
      >
        {children}
      </StyledGridDiv>
    );

    return message ? (
      <Tooltip position={tooltipLocation ?? 'top'} contents={message} color={color} style={{ fontSize: '12px' }}>
        {errorContent}
      </Tooltip>
    ) : (
      errorContent
    );
  }
  return (
    <StyledGridDiv
      $minWidth={minWidth}
      $maxWidth={maxWidth}
      data-e2e={`${inputId}-grid-form-group`}
      className={className}
    >
      {children}
    </StyledGridDiv>
  );
};

GridFormGroup.displayName = 'GridFormGroup';
